<script type="ts">
    import {fade} from 'svelte/transition';
    import {createEventDispatcher, SvelteComponent} from 'svelte';

    const dispatch = createEventDispatcher();

    export let className: string = '';
    export let id: string = '';
    export let duration: number = 800;
    export let slot: {
        Component: typeof SvelteComponent,
        props?: Array<any>,
    } | undefined = undefined;

    let visible = false;

    export function show() {
        visible = true;
        return new Promise(resolve => setTimeout(resolve, duration));
    }

    export function hide() {
        visible = false;
        return new Promise(resolve => setTimeout(resolve, duration));
    }

    export function dismiss() {
        dispatch('dismiss');
        hide();
    }
</script>

<svelte:window
    on:keydown={(e) => {
        if(e.which == 27)
            hide();
    }}
/>

{#if visible}
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    transition:fade|local={{duration: 300}}
    on:click|self={dismiss}
    class="popup"
>
    <div class={className} id={id}>
        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- svelte-ignore a11y-missing-content -->
        <a rel="back" on:click={dismiss}></a>
        <section>
        {#if slot}
            <svelte:component this={slot.Component} {...slot.props} />
        {:else}
            <slot />
        {/if}
        </section>
    </div>
</div>
{/if}
